import TableList from "@components/templates/tablelist";
import { HttpGetReleaseListByManagement,HttpEditCalculationReleaseByManagement,HttpGetAccountAgreementList,HttpGetStatusNumByAdmin } from "@/service/products/calculationRelease";
import { mapGetters } from "vuex";
import exportModal from "./exportModal";
import comIndex from './../update'
import mixin from "./../mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
        exportModal
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: { show: true },
            spanTabs: { show: true },
            accountAgreementList: [],
            formData:{
                search: {
                    EQ_status:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData: '',
            fieldMapping: {
                DA: "daPointScale",
                Freight: "freightPointScale",
                COOP: "coopPointScale",
                Termsdiscount: "termsdiscountPointScale",
            },
        };
    },

    methods: {
        ajaxRequest: HttpGetReleaseListByManagement,
        spanAjaxRequest:HttpGetStatusNumByAdmin,
        interceptRequest: (params) => {
            if (params.search.EQ_status == null) {
                params.search.IN_status = null
            } else if(params.search.EQ_status == 1){
                params.search.IN_status = 1
            } else if(params.search.EQ_status == 2){
                params.search.IN_status = [4,7]
            }
            delete params.search.EQ_status;

            const {CN_asin } = params.search;
            let IN_asin;
            if(CN_asin){
                IN_asin = CN_asin.replace(/\n/g,",");
            }
            params.search.IN_asin = IN_asin;
            delete params.search.CN_asin;

            return params;
        },
        async loadAccountOptions(releaseId) {
            try {
                const res = await HttpGetAccountAgreementList({
                    contextId: global.SYSID,
                    releaseId: releaseId
                });
                this.accountAgreementList = res.data || [];
                // 格式化数据
                this.accountAgreementList.forEach((item) => {
                    const result = [];
                    if (item) {
                        Object.entries(this.fieldMapping).forEach(([displayName, fieldName]) => {
                            if (item.hasOwnProperty(fieldName)) {
                                const value = item[fieldName];
                                result.push(`${displayName}:${value != null ? value + "%" : 0}`);
                            }
                        });
                    }
                    item.term = result.join("; ");
                });
                return this.accountAgreementList;
                
            } catch (error) {
                this.accountAgreementList = [];
                return [];
            }
        },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "edit":
                    this.$router.push({
                        name: 'calculationReleaseAdminUpdate',
                        params: { type: "edit"},
                        query: { id: params },
                    });
                    break;
                case "completed":
                    this.$router.push({
                        name: 'calculationReleaseAdminUpdate',
                        params: { type: "completed"},
                        query: { id: params },
                    });
                    break;
                case 'confirmPush':
                    this.operate = {
                        show: true,
                        alert: 'success',
                        width:700,
                        params: {
                            id: params,
                            isPush: 1,
                            status: 6
                        },
                        formdata: [
                            {
                                span: 24,
                                label: "店铺",
                                tag: "vSelect",
                                key: "accountFlag",
                                options: [], // 初始为空
                                loading: true, // 显示加载状态
                                props: {
                                    filterable: true,
                                },
                            },
                        ],
                        title: "上架成功",
                        desc: "确定上架成功吗？",
                        ajaxRequest: (data) => {
                            const value = this.accountAgreementList.find(
                                (item) => item.id === data.accountFlag
                            );
                            data.channelId = value.accountId;
                            data.channelFlag = value.accountFlag;
                            data.vendorCode = value.vendorCode;
                            data.term = value.term;
                            return HttpEditCalculationReleaseByManagement(data);
                        }
                    }
                    // 加载店铺数据
                    this.loadAccountOptions(params).then(accountList => {
                        // 更新弹框中的店铺选项
                        const selectField = this.operate.formdata.find(item => item.key === 'accountFlag');
                        if (selectField) {
                            selectField.options = accountList.map(item => ({
                                value: item.id,
                                label: item.accountFlag + "(" + item.vendorCode + ":" + (item.term || '') + ")"
                            }));
                            selectField.loading = false;
                        }
                    });
                    break;
                case "refusePush":
                    this.operate = {
                        show: true,
                        showDesc: false,
                        alert: "error",
                        title: "上架失败",
                        width: 460,
                        params: {
                            id: params,
                            isPush: 1,
                            status: 5
                        },
                        formdata: [
                            {
                                span: 24,
                                label: '异常类型:',
                                key: 'exceptionType',
                                tag: 'vRadio',
                                labelWidth: 'auto',
                                value: 0,
                                props: {
                                    strict: false,
                                },
                                options: [{
                                    trueValue: 0,
                                    label: '基本信息异常'
                                }, {
                                    trueValue: 1,
                                    label: '价格审核不通过'
                                }]
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注:",
                            }
                        ],
                        ajaxRequest: (data) => {
                            // 提交前处理数据
                            if (data.exceptionType === undefined || data.exceptionType === null) {
                                data.exceptionType = 0; // 设置默认值
                            }
                            return HttpEditCalculationReleaseByManagement(data);
                        }
                    };
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "测算结果导入",
                        width: 800,
                        component: exportModal,
                        showFooter: false,
                        showDesc: false,
                    };
                    break;
                // case 'export':
                //     if(this.total>2000){
                //         this.$VMessage.error('导出数据不能大于2000');
                //     }else{
                //         this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/promotionResource/exportByFilter',this.formData,{
                //             executor:'request',
                //             download:true,
                //         }).catch(err=>{
                //             this.$VMessage.error({
                //                 content: err.message,
                //                 duration: 30,
                //                 closable: true
                //             });
                //         });
                //     }
                //     break;
            }
        },
        getOperateNodeMap(row){
            const { id,status,adjustStatus } = row
            return [
                {
                label:'查看',
                show:true,
                params:id,
                operate:'query'
                },
                {
                label:'测算结果',
                show:status ==1 && adjustStatus ==0,
                params:id,
                operate:'edit'
                },
                {
                label:'确认上架',
                show:(status ==4||status==7) && adjustStatus ==0,
                params:id,
                operate:'confirmPush'
                },
                {
                label:'上架失败',
                show:(status ==4||status==7) && adjustStatus ==0,
                params:id,
                operate:'refusePush'
                },
                {
                label:'调价测算结果',
                show:adjustStatus ==1,
                params:id,
                operate:'completed'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList']),
        TabsData(){
            return [
                {
                    name: "全部",
                    key:'EQ_status',
                    val: null
                }, {
                    name: "待测算",
                    key:'EQ_status',
                    val: 1,
                    spanKey: 'calculated',
                }, {
                    name: "上架中",
                    key:'EQ_status',
                    val: 2,
                    spanKey: 'listing',
                },
            ]
        },
        ToolsData(){
            return [
                {
                    name: "测算结果导入",
                    operate: "import",
                    theme: "primary",
                },
                // {
                //     name: "查询条件导出",
                //     operate: "export",
                //     theme: "primary",
                // },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    tag: "Select",
                    key: "IN_orgId",
                    show:true,
                    options: this.getOrgList,
                    props: {
                        multiple: true,
                        filterable:true,
                    },
                },
                {
                    label: "产品名",
                    tag: 'vInput',
                    key: 'EQ_productName',
                    show:true,
                },
                {
                    label: "型号",
                    tag: 'vInput',
                    key: 'EQ_productCode',
                    show:true,
                },

                // 隐藏起来的搜索
                {
                    label: "ASIN",
                    tag: 'vTextarea',
                    key: 'CN_asin',
                    style: "width:200px",
                    props:{
                        placeholder:"支持输入多个，一行一个ASIN",
                    },
                },
                {
                    label: "更新者",
                    tag: 'vInput',
                    key: 'CN_updatedName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '更新时间',
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render:this.getOperateNodes,
                },
                {
                title: this.$t('global.common.organization',{defaultValue:'组织'}),
                width:90,
                render: (h, { row }) => {
                    const id = row.orgId;
                    const org = this.getOrgList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div><span class="font-bold">{org.label}</span></div>
                    </div>
                    }
                },
                {
                    title: this.$t('global.common.base_information', { defaultValue: '基本信息' }),
                    render: (h, { row }) => {
                        return <div class="icon-main-container">
                            <div>
                                <div>
                                    <span class="font-bold">ASIN: </span>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.asin}</a>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon
                                        class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                                </div>
                                <div><span class="font-bold">产品名: </span>{row.productName || '--'}</div>
                                <div><span class="font-bold">型号: </span>{row.productCode || '--'}</div>
                            </div>
                        </div>
                    },
                },
                {
                    title: '测算信息',
                    render: (h, { row }) => {                        
                        if (row.adjustVcPrice != undefined && row.adjustVcPrice != 0 && row.adjustPurchasePrice != undefined && row.adjustPurchasePrice != 0) {
                            return <div class="icon-main-container">
                                <div>
                                <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustVcPrice} ) </span></div>
                                <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustPurchasePrice} ) </span></div>
                                <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                            </div>
                        </div> 
                        } else if(row.adjustVcPrice != undefined && row.adjustVcPrice != 0) {
                            return <div class="icon-main-container">
                            <div>
                                <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustVcPrice} ) </span></div>
                                <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}</div>
                                <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                            </div>
                        </div>  
                        }else if(row.adjustPurchasePrice != undefined && row.adjustPurchasePrice != 0) {
                            return <div class="icon-main-container">
                                <div>
                                    <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                    <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                    <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}</div>
                                    <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustPurchasePrice} ) </span></div>
                                    <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                    <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                    <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                    <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                    <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                    <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                                </div>
                            </div>  
                        } else {
                            return <div class="icon-main-container">
                                <div>
                                    <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                    <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                    <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}</div>
                                    <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}</div>
                                    <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                    <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                    <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                    <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                    <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                    <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                                </div>
                            </div>
                        }
                    },
                },
                {
                    title: '测算结果',
                    render: (h, { row }) => {
                        return <div class="icon-main-container">
                            <div>
                                <div><span class="font-bold">店铺: </span>{row.channelFlag || '--'}</div>
                                <div><span class="font-bold">销售价: </span>{row.sellingPrice || '--'}</div>
                                <div><span class="font-bold">供货价: </span>{row.supplyPrice|| '--'}</div>
                                <div><span class="font-bold">广告投入: </span>{row.advertisingInvestment|| '--'}</div>
                                <div><span class="font-bold">最终回款: </span>{row.paymentCollection|| '--'}</div>
                                <div><span class="font-bold">运费预估: </span>{row.freightEstimation|| '--'}</div>
                                <div><span class="font-bold">amazon利润占比: </span>{row.amazonProfit || '--'}</div>
                                <div><span class="font-bold">客户利润占比: </span>{row.customerProfit || '--'}</div>
                                <div><span class="font-bold">Term: </span>{row.term|| '--'}</div>
                            </div>
                        </div>
                    },
                },
                {
                    title: '状态',
                    key: 'status',
                    width:150,
                    render: (h, { row }) => {
                        const status = row.status;
                        // 更安全的查找和默认值处理
                        const foundItem = this.statusList.find(item => item.value == status);
                        return (
                            <vButton
                                ghost
                                theme={foundItem.theme}
                                size="small"
                                class={{ 
                                    'cursor-not-allowed': true, // 修正类名
                                    'width-70': true 
                                }}
                            >
                                {foundItem.label}
                            </vButton>
                        );  
                    }
                },
                {
                    title: '调价状态',
                    key: 'adjustStatus',
                    width:150,
                    render: (h, { row }) => {
                        const adjustStatus = row.adjustStatus;
                        if (adjustStatus != 0) {
                            // 更安全的查找和默认值处理
                            const foundItem = this.adjustStatusList.find(item => item.value == adjustStatus);
                            return (
                                <vButton
                                    ghost
                                    theme={foundItem.theme}
                                    size="small"
                                    class={{
                                        'cursor-not-allowed': true, // 修正类名
                                        'width-80': true
                                    }}
                                >
                                    {foundItem.label}
                                </vButton>
                            );
                        } else {
                            return<div>无</div>
                        }
                    }
                },
                {
                    title: '更新者',
                    width:150,
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.updatedName || '--'}</span></div>
                        </div>
                    },
                },
                {
                    title: '更新时间',
                    width:150,
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.updatedAt || '--'}</span></div>
                        </div>
                    },
                },
            ];
        },

    },

};
